module.exports = __webpack_public_path__ + "img/feedback-history.259eaf6.png";